export const addReviews = (data) => {
    return {
        type: 'ADD_REVIEWS',
        payload:data
    }
}